import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import {
  bandeauAlertContainer,
  bandeauAlertTitle,
  sectionAlertModal,
  sectionAlert,
  sectionAlertHeader,
  sectionAlertContent,
  sectionAlertButton,
  sectionAlertTitle,
  editButton,
} from "./bandeau-alert.module.scss"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import {
  Title,
  SectionAlert,
  SectionAlertButton,
  SectionAlertContent,
  BandeauContainer,
} from "./bandeau-alert-styled"
import Icon from "gatsby-theme-blank/src/components/Icon/icon"

const BandeauAlert = ({ alertContent }) => {
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    const visited = sessionStorage.alertBool
    if (visited) {
      setShowAlert(false)
    } else {
      setShowAlert(true)
      sessionStorage.setItem("alertBool", true)
    }
  }, [])

  // Partie RGAA

  const [activeIndex, setActiveIndex] = useState(-1)
  const activeIndexRef = useRef(activeIndex)
  const setActiveIndexValue = (newIndex) => {
    activeIndexRef.current = newIndex
    setActiveIndex(newIndex)
  }
  const [focusableElements, setFocusableElements] = useState([])
  const modalRef = useRef(null)

  const handleEscape = (event) => {
    if (event.key === "Escape") setShowAlert(false)
  }

  const handleTab = (event) => {
    let actualFocusableElements = focusableElements
    if (modalRef && !focusableElements?.length) {
      actualFocusableElements = modalRef.current?.querySelectorAll(
        "a, button, textarea, input, select"
      )
      setFocusableElements(actualFocusableElements)
    }

    const total = actualFocusableElements?.length
    if (!total) return
    let localActiveIndex = activeIndexRef.current

    // Tab navigation
    if (!event.shiftKey) {
      localActiveIndex =
        localActiveIndex + 1 === total
          ? (localActiveIndex = 0)
          : (localActiveIndex += 1)

      actualFocusableElements[localActiveIndex].focus()
      setActiveIndexValue(localActiveIndex)
      return event.preventDefault()
    }

    // Tab navigation avec shift
    if (event.shiftKey) {
      localActiveIndex =
        localActiveIndex - 1 < 0
          ? (localActiveIndex = total - 1)
          : (localActiveIndex -= 1)

      actualFocusableElements[localActiveIndex].focus()
      setActiveIndexValue(localActiveIndex)
      return event.preventDefault()
    }
  }

  const keyListenersMap = new Map([
    [27, handleEscape],
    [9, handleTab],
  ])

  const handleKeydown = (event) => {
    const listener = keyListenersMap.get(event.keyCode)
    return listener && listener(event)
  }

  // Requis à cause du re-render qui duplique les listeners
  const handleKeyDownRef = useRef(handleKeydown)

  useEffect(() => {
    setActiveIndexValue(-1)
    if (!showAlert) {
      if (typeof document !== `undefined`) {
        document.removeEventListener("keydown", handleKeyDownRef.current)
      }
    } else if (typeof document !== `undefined`) {
      document.removeEventListener("keydown", handleKeyDownRef.current)
      document.addEventListener("keydown", handleKeyDownRef.current)
    }
  }, [showAlert])

  return (
    <div ref={modalRef}>
      {alertContent && (
        <>
          <BandeauContainer
            onClick={() => {
              setShowAlert(true)
            }}
            onKeyDown={(event) => {
              // 13 = Enter, 32 = Space
              if (event.keyCode === 13 || event.keyCode === 32) {
                event.preventDefault()
                setShowAlert(true)
              }
            }}
            className={bandeauAlertContainer}
            tabIndex="0"
            role="button"
            title="Ouverture du message important"
          >
            <h2 className={bandeauAlertTitle}>MESSAGE IMPORTANT</h2>
            <div>
              <Icon size={16} icon="notification"></Icon>
            </div>
          </BandeauContainer>
          {showAlert && (
            <div
              className={sectionAlertModal}
              role="dialog"
              aria-modal="true"
              onClick={(event) => {
                // On empêche que cliquer sur l'enfant ferme aussi la popup
                if (event.target !== event.currentTarget) return
                setShowAlert(false)
                sessionStorage.setItem("alertBool", true)
              }}
            >
              <SectionAlert className={sectionAlert}>
                <div className={sectionAlertHeader}>
                  <Title className={sectionAlertTitle}>Message important</Title>
                  <SectionAlertButton
                    className={sectionAlertButton}
                    onClick={() => {
                      setShowAlert(false)
                      sessionStorage.setItem("alertBool", true)
                    }}
                    aria-label={"Fermer la modale message important"}
                  >
                    <span aria-hidden={"true"}>&times;</span>
                  </SectionAlertButton>
                </div>
                <SectionAlertContent className={sectionAlertContent}>
                  <EditButton
                    addedClass={editButton}
                    link={"/admin/site-configuration"}
                  />
                  <ContentTransformer
                    content={alertContent}
                  ></ContentTransformer>
                </SectionAlertContent>
              </SectionAlert>
            </div>
          )}
        </>
      )}
    </div>
  )
}

//-----------------------Prop-Types---------------------------//

BandeauAlert.propTypes = {
  alertContent: PropTypes.string,
}

//-----------------------Prop-Types---------------------------//

export default BandeauAlert
